<template>
  <div class="plans-page">
    <h1>{{$ml.get(`Our plans`)}}</h1>
    <div v-if="$store.getters['user/data'].fromUpdatedPrice == 0" class="plans">
      <SidebarSwitcher
        @input="selectType"
        :items="[
          {
            key: 'monthly',
            label: 'Monthly',
          },
          {
            key: 'year',
            label: $ml.get(`year`),
          },
        ]"
        :value="period"
      />

      <div class="item">
        <div class="title">
          <h2>
            {{ plans[0].name }}
          </h2>
          <span>
            GBP {{ plans[0].price }}
          </span>
        </div>
        <div class="content">
          <ul type="circle">

          </ul>
          <app-btn @click="openPlan(plans.find(x=> x.key == 'impact'))" size="big">
            {{ $ml.get(`Buy`) }}
          </app-btn>
        </div>
      </div>

      <div class="item" v-for="plan in plans" :key="plan.key" v-if="plan.id > 0">
        <div class="title">
          <h2>
            {{ plan.name }}
          </h2>
          <span v-if="period == 'year'">
            GBP {{ plan.pricePerYear != null ? plan.pricePerYear : plan.pricePerMonth }} /
            {{ plan.pricePerYear != null ? $ml.get(`year`) : $ml.get(`one-time`) }}
          </span>
          <span v-else>
            GBP {{ plan.pricePerMonth != null ? plan.pricePerMonth : plan.pricePerMonth }} /
            {{ plan.pricePerMonth != null ? 'month' : $ml.get(`one-time`) }}
          </span>
        </div>
        <div class="content">
          <ul type="circle">
            <li v-if="dataPlans[plan.id]" v-for="line in dataPlans[plan.id]" v-html="line"></li>
          </ul>
          <app-btn @click="openPlan(plan)" size="big">
            {{ $ml.get(`Buy`) }}
          </app-btn>
        </div>
      </div>
    </div>

    <div v-else class="plans">
      <div class="item" v-for="plan in newPlans" :key="plan.key">
        <div class="title">
          <h2>
            {{ plan.name }}
          </h2>
          <span v-if="plan.key != 'elite'">
            GBP {{ plan.price}} / year
          </span>
          <span v-else>
          </span>
        </div>
        <div class="content">
          <!-- <ul type="circle">
            <li v-if="newPlans[plan.id]" v-for="line in newPlans[plan.id]" v-html="line"></li>
          </ul> -->
          <app-btn v-if="plan.key != 'elite'" @click="openPlan(plan)" size="big">
            {{ $ml.get(`Buy`) }}
          </app-btn>

          <a id="contact-us-btn" v-else href="mailto:support@smart-fertilizer.com">Contact Us</a>
        </div>
      </div>
    </div>

    <transition name="modal-fade-scale">
      <PaymentModal
        v-if="show_modal"
        :plan="selected_plan"
        :period="period"
        :price="price"
        @close="show_modal = false"
      />
    </transition>

  </div>
</template>

<script>
import API from '@/api'
import PaymentModal from '@/components/plans/PaymentModal'
import dataPlans from './plans.data.js'
import SidebarSwitcher from '@/components/common/SidebarSwitcher'

export default {
  data() {
    return {
      plans: dataPlans,
      price: 0,
      period: 'monthly',
      show_modal: false,
      selected_plan: {},
      dataPlans: {
        1: [
          // this.$ml.get(`<span class="highlight">One-Time</span> Fertilization Data Report`),
          // this.$ml.get(`Includes regional specifications`),
          // this.$ml.get(`Includes <span class="highlight">1</span> crop`),
        ],
        2: [
          // this.$ml.get(`<span class="highlight">One-Time</span> Fertilization Plan`),
          // this.$ml.get(`Includes <span class="highlight">1</span> personalised fertilization plan based on your soil, water and tissue tests`),
          // this.$ml.get(`Includes <span class="highlight">1</span> crop`),
        ],
        3: [
          // this.$ml.get(`Annual License`),
          // this.$ml.get(`<span class="highlight">45</span> Personalised Fertilization Plans Based on Soil, Water & Tissue Tests`),
          // this.$ml.get(`Includes <span class="highlight">7</span> crops`),
          // this.$ml.get(`<span class="highlight">1</span> user`),
        ],
        4: [
          // this.$ml.get(`Annual License`),
          // this.$ml.get(`<span class="highlight">250</span> Personalised Fertilization Plans Based on Soil, Water & Tissue Tests`),
          // this.$ml.get(`Includes <span class="highlight">20</span> Crops`),
          // this.$ml.get(`<span class="highlight">1</span> user`),
        ],
        5: [
          // this.$ml.get(`Annual License`),
          // this.$ml.get(`<span class="highlight">Unlimited</span> Personalised Fertilization Plans Based on Soil, Water & Tissue Tests`),
          // this.$ml.get(`Includes <span class="highlight">Unlimited</span> Crops`),
          // this.$ml.get(`<span class="highlight">3</span> users`),
        ]
      },
      newPlans: [
        {
          "id": 1,
          "key": "Exact_IPNUK",
          "name": "exact",
          "price": 1200,
          "systemCrops": 7,
          "personalCrops": 5,
          "plans": 45,
        },
        {
          "id": 2,
          "key": "Premium_IPNUK",
          "name": "premium",
          "price": 3600,
          "systemCrops": 20,
          "personalCrops": 5,
          "plans": 250,
        },
        {
          "id": 3,
          "key": "elite",
          "name": "elite Corporate",
          "price": 0,
          "systemCrops": 0,
          "personalCrops": 0,
          "plans": 0,
        },
      ]
    }
  },
  methods : {
    sync() {
      return API.misc.getPlans().then(res => {
        this.plans = res.data.data;
        // console.log(JSON.stringify(this.plans, null, 2));
      });
    },
    selectType(type) {
      this.period = type;
    },
    openPlan(plan) {
      this.show_modal = true;
      this.selected_plan = plan.key;
      if(this.$store.getters['user/data'].fromUpdatedPrice == 0) {
        if (plan.key == 'impact') {
          this.price = plan.price;
        } else if (this.period == 'year') {
          this.price = plan.pricePerYear
        } else {
          this.price = plan.pricePerMonth;
        }
      } else {
        this.price = plan.price;
        this.period = 'year';
      }
    },
  },
  created() {
    if (this.$store.getters['user/data'].connectsTo != 0) {
      this.$router.push('/dashboard/');
    }

    // this.sync();


    // @FACEBOOK-PIXEL
    // fbq('track', 'Contact');
  },
  components: {
    PaymentModal,
    SidebarSwitcher,
  },
  computed: {
    hisPlanId() {
      // TODO: deprecate it
      const plans = {
        'exact': 3,
        'premium': 4,
        'elite': 5,
      }

      return plans[this.$store.getters['user/plan']] || 0;
    }
  }
}
</script>

<style lang="scss" scoped>
#contact-us-btn {
  background: $mainGreen;
  border: 1px solid $mainGreen;
  transition: box-shadow 0.3s ease, padding 0.3s ease, transform 0.3s ease, -webkit-box-shadow 0.3s ease, -webkit-transform 0.3s ease;
  padding: 12px 20px;
  min-width: 0;
  border-radius: 5px;
  min-height: 32px;
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
  text-transform: uppercase;
  position: relative;
  overflow: hidden;
  width: auto;
  white-space: nowrap;
  appearance: none;
  color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  letter-spacing: 1px;
  font-size: 17px;
  user-select: none;
}
 
::v-deep {
  .highlight {
    color: #6CB65E;
    font-weight: bold;
  }
}
.plans-page {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  min-height: 100%;
  height: 100%;
  padding: 28px 0;

  h1 {
    margin: 0;
    margin-bottom: 28px;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 33px;
    color: #4C5056;
  }

  .plans {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .item {
      width: 100%;
      padding: 35px 24px;
      display: flex;
      align-items: center;
      background: white;
      margin:4px 0 12px;
      // box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
      border-radius: 5px;

      &:first-child {
        margin-top: 12px;
      }
      &:last-child {
        margin-bottom: 12px;
      }

      .title {
        width: 30%;
        display: flex;
        flex-direction: column;
        align-items: center;

        h2 {
          font-family: Manrope;
          font-style: normal;
          font-weight: 600;
          font-size: 33px;
          text-align: center;
          color: #4C5056;
          margin: 0;
          margin-bottom: 8px;

          &::first-letter {
            text-transform: uppercase;
          }
        }

        span {
          font-family: Manrope;
          font-style: normal;
          font-weight: normal;
          font-size: 19px;
          text-align: center;
          color: #4C5056;

        }
      }

      .content {
        width: 70%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: end;
        align-items: center;
        box-sizing: border-box;

        ul {
          // margin: 36px 0;
          margin: 0;
          max-width: 400px;
          flex-grow: 1;
        }

        ul li {
          list-style-type: none;
          position: relative;
          margin-bottom: 10px;
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          color: #4C5056;

          &:last-child {
            margin-bottom: 0;
          }
        }
        ul li:before {
          content: '';
          left: -17px;
          top: 6px;
          position: absolute;
          display: block;
          width: 6px !important;
          height: 6px !important;
          border: 2px solid #8ACB7B;
          border-radius: 50%;
          box-sizing: border-box;
        }

        .btn {
          margin: 15px 0;
        }
      }
    }
  }
  @media (max-width: 768px) {
    .plans {
      .item {
        flex-direction: column;
        .title {
          width: 100%;
          margin-bottom: 16px;
          span {

          }
        }
        .content {
          width: 100%;
          .circle {

          }
        }
      }
    }
  }
}
</style>
